import React, { useEffect, useState } from 'react';
import {
  FDContentContainer, FDPaper, FDStack, PrimaryActionButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import fr from 'facet-rest';
import { ClickableTextRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ClickableTextRel';
import { HeadlineTextSmall, LabelTextLarge } from 'Packages/FacetDesign/Components';
import InvestorProfileSections from 'Views/Page/Content/Templates/InvestorProfilePageTemplate/InvestorProfileSections';

const Layout = () => {
  const { onSubmit, resource } = useMetaLayoutContext();
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();
  const [sections, setSections] = useState(null);
  const [loadingSections, setLoadingSections] = useState(true);

  // Get the sections from relationship
  async function getSections() {
    try {
      const investmentSectionCollection = await resource.withRelationship(
        fr.relationships.investmentSection.name,
        async (rel) => rel.getRelated(),
        () => null,
      );

      setSections(investmentSectionCollection);
    } catch (err) {
      displayErrorMessage();
    } finally {
      setLoadingSections(false);
    }
  }

  useEffect(() => {
    getSections();
  }, [resource]);

  const handleSubmit = async () => {
    try {
      await onSubmit({ rejectOnError: true });
      displaySuccess('Investor profile updated');
    } catch (err) {
      displayErrorMessage(err, 'Error updating investor profile');
    }
  };


  return (
    <FDContentContainer maxWidth={'lg'}>
      <FDStack direction={'column'} alignItems={'stretch'} spacing={3} paddingY={2}>
        <MetaControlField attr="title" />
        <FDStack spacing={3} direction={'row'}>
          <InvestorProfileSections
            loading={loadingSections}
            collection={sections}
          />
        </FDStack>
        <FDPaper appearance={'flat'} padding={400} width={'50%'} flex={1}>
          <HeadlineTextSmall value={'Direct Indexing Preferences'} color={'textSecondary'} />
          <FDStack direction={'column'} spacing={3} paddingY={3}>
            <FDStack direction={'column'}>
              <MetaControlField attr={'directIndexingPersonaTitle'} />
              <MetaControlField attr={'directIndexingPersonaSubTitle'} />
              { resource.withRelationship(
                fr.relationships.directIndexingPersonInfo.name,
                (rel) => (<ClickableTextRel relationship={rel} appearance="standalone" />),
                () => null,
              )}
            </FDStack>
            <MetaControlField attr={'directIndexingPersona'} onInlineSubmit={handleSubmit} />
          </FDStack>
          <FDStack direction={'column'} spacing={3} paddingY={3}>
            <FDStack direction={'column'}>
              <MetaControlField attr={'rejectedDirectIndexTickerOptionsTitle'} />
              <MetaControlField attr={'rejectedDirectIndexTickerOptionsSubTitle'} />
            </FDStack>
            <MetaControlField attr={'rejectedDirectIndexTickersForPersonalReasons'} />
            <MetaControlField attr={'rejectedDirectIndexTickersForComplianceReasons'} />
            <PrimaryActionButton onClick={handleSubmit} label={'Save'} isFullWidth={false} />
            <LabelTextLarge value={'The values-aligned option selected and individual holdings excluded above apply only to this direct indexing strategy.'} />
          </FDStack>
        </FDPaper>
      </FDStack>
    </FDContentContainer>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
